/** @format */

import React, { createContext, useContext, useState, useEffect } from "react";


const AuthContext = createContext();

export const useAuth = () => {
  return useContext(AuthContext);
};

export default function AuthContextProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(
    JSON.parse(localStorage.getItem("username")) || ""
  );
  const [userId, setUserId] = useState(JSON.parse(localStorage.getItem("userId")) || null)
  const [authed, setAuthed] = useState(
    JSON.parse(localStorage.getItem("authed")) || false
  );

  const [isAdmin, setIsadmin] = useState(
    JSON.parse(localStorage.getItem("isAdmin")) || false
  );

  const [accessToken, setAccessToken] = useState(JSON.parse(localStorage.getItem("accessToken")) || null)

  const signIn = (userData) => {
    setCurrentUser(userData.username);
    userData.role === "ADMIN" ? setIsadmin(true) : setIsadmin(false);
    setAuthed(true);
    setAccessToken(userData.access_token);
    setUserId(userData.vendorId);
  };

  const signOut = async (inputs) => {
    //await axios.post("/auth/signOut");
    setCurrentUser("");
    setAuthed(false);
    setIsadmin(false);
    setAccessToken(null);
    setUserId(null);
    //return {error: "password not found"}
  };

  useEffect(() => {
    localStorage.setItem("username", JSON.stringify(currentUser));
  }, [currentUser]);

  useEffect(() => {
    localStorage.setItem("isAdmin", JSON.stringify(isAdmin));
  }, [isAdmin]);

  useEffect(() => {
    localStorage.setItem("authed", JSON.stringify(authed));
  }, [authed]);

  useEffect(() => {
    localStorage.setItem("userId", JSON.stringify(userId));
  }, [userId])

  useEffect(() => {
    localStorage.setItem("accessToken", JSON.stringify(accessToken));
  }, [accessToken])

  return (
    <AuthContext.Provider
      value={{ currentUser, authed, userId, accessToken, signIn, signOut, isAdmin }}>
      {children}
    </AuthContext.Provider>
  );
}
